import {createStore} from 'vuex'
import axios from '../axios.config.js'
import Swal from 'sweetalert2'
import {eventBus} from '@/eventBus';
import texts from '/./texsts.js';
import lang from './modules/lang';
import {log} from "@/utils/clientLogger.js";

export default createStore({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        role: "",
        user: {},
        statuses: [],
        isInitialDataLoaded: false
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        userToken: state => state.token,
        isAdmin: state => state.role === 'admin',
        isManager: state => state.role === 'manager' || state.role === 'admin',
        isDraftsman: state => state.role === 'draftsman' || state.role === 'admin',
        isDistributor: state => state.role === 'distributor' || state.role === 'admin',
        userRole: state => state.role,
        userData: state => state.user,
        allStatuses: state => state.statuses
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, payload) {
            state.status = 'success'
            state.token = payload.token
            state.user = payload.user
            state.role = payload.user.role?.name
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        setUserData(state, payload) {
            state.role = payload.user.role?.name;
            state.user = payload.user;
        },
        setLanguage(state, lang) {
            state.language = lang;
        },
        setStatuses(state, statuses) {
            state.statuses = statuses;
        },
        SET_INITIAL_DATA_LOADED(state, status) {
            state.isInitialDataLoaded = status;
        }
    },
    actions: {
        async login({commit, dispatch}, user) {
            commit('auth_request');
            try {
                const resp = await axios({url: '/api/login', data: user, method: 'POST'});

                const token = resp.data.token;
                const initialUser = resp.data.user;

                localStorage.setItem('token', token);
                eventBus.emit('update-token', token);
                commit('auth_success', {token, user: initialUser});

                commit('SET_INITIAL_DATA_LOADED', false); // Скидаємо прапорець при логіні
                await dispatch('fetchUserData');

                return resp; // Повертаємо успішну відповідь
            } catch (err) {
                Swal.fire({
                    title: texts.titles.error,
                    text: err?.response?.data?.message,
                    icon: 'error',
                });
                commit('auth_error');
                localStorage.removeItem('token');
                throw err;
            }
        },
        register({commit}, user) {

            return new Promise((resolve, reject) => {
                commit('auth_request')

                axios({url: '/api/register', data: user, method: 'POST'}).then(resp => {
                    const token = resp.data.token
                    const user = resp.data.user
                    localStorage.setItem('token', token)
                    eventBus.emit('update-token', token);
                    commit('auth_success', token, user)
                    resolve(resp)
                }).catch(err => {
                    Swal.fire({
                        title: texts.titles.error,
                        text: err?.response?.data?.message,
                        icon: 'error',
                    });
                    commit('auth_error', err)
                    localStorage.removeItem('token')
                    reject(err)
                })
            })
        },
        logout({commit}) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                eventBus.emit('update-token', null);
                delete axios.defaults.headers.common['Authorization']
                commit('SET_INITIAL_DATA_LOADED', false); // Скидаємо прапорець при логіні

                resolve()
            })
        },
        fetchUserData({commit}) {
            if (!this.getters.isLoggedIn) {
                return Promise.reject('Not logged in');
            }

            return new Promise((resolve, reject) => {
                axios.get('/api/user', {
                    headers: {Authorization: localStorage.getItem('token')}
                }).then(tokenResponse => {
                    const basicUserData = tokenResponse.data.user;

                    if (!basicUserData || !basicUserData._id) {
                        return reject('Invalid user data from token');
                    }
                    const userId = basicUserData._id;

                    return axios.get(`/api/user/${userId}`);
                }).then(dbResponse => {
                    const fullUser = dbResponse.data;
                    commit('setUserData', {user: fullUser});
                    commit('SET_INITIAL_DATA_LOADED', true);
                    resolve(dbResponse);
                }).catch(error => {
                    Swal.fire({
                        title: texts.titles.error,
                        text: error?.response?.data?.message,
                        icon: 'error',
                    });
                    log.error('Error fetching user data', {'error': error});
                    reject(error);
                });
            });
        },
        fetchStatuses({commit}) {
            return new Promise((resolve, reject) => {
                axios.get('/api/statuses').then(response => {
                    commit('setStatuses', response.data);
                    resolve(response);
                }).catch(error => {
                    log.error('Error fetching statuses', {'error': error});
                    reject(error);
                });
            });
        }
    },
    modules: {
        lang
    }
})
